import React from 'react';
import { Trans } from '@lingui/react/macro';
import { Accordion, Checkbox, CheckboxGroup } from '@ygtechnologies/rubus-ui';

import { classnames } from '@/utils/html';
import { useOptionsFilter } from '../useOptionsFilter';
import type { OptionsFilterFacets } from '../useOptionsData';
import theme from './FilterSidebar.module.scss';

interface Props {
    facets: OptionsFilterFacets;
}

function toggle(ids: number[], id: number): number[] {
    return ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id];
}

export const RoomFilter: React.FC<Props> = ({ facets }) => {
    const { filter, setRoomIds, setTagIds } = useOptionsFilter();

    if (facets.rooms.length === 0 && facets.tags.length === 0) return null;

    return (
        <Accordion
            variant="elevated"
            defaultOpen
            title={
                <span className={theme.filterTitle}>
                    <Trans>Room filters</Trans>
                </span>
            }>
            <div className={theme.filterBody}>
                {facets.rooms.length > 0 && (
                    <CheckboxGroup>
                        {facets.rooms.map((room) => (
                            <Checkbox
                                key={room.id}
                                inputSize="md"
                                checked={filter.roomIds.includes(room.id)}
                                onChange={() => setRoomIds(toggle(filter.roomIds, room.id))}>
                                {room.name}
                            </Checkbox>
                        ))}
                    </CheckboxGroup>
                )}
                {facets.tags.length > 0 && (
                    <div className={classnames({ [theme.tagSection]: facets.rooms.length > 0 })}>
                        <CheckboxGroup>
                            {facets.tags.map((tag) => (
                                <Checkbox
                                    key={tag.id}
                                    inputSize="md"
                                    checked={filter.tagIds.includes(tag.id)}
                                    onChange={() => setTagIds(toggle(filter.tagIds, tag.id))}>
                                    {tag.name}
                                </Checkbox>
                            ))}
                        </CheckboxGroup>
                    </div>
                )}
            </div>
        </Accordion>
    );
};
